import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

const NewsletterSubscribeWidgetReusable = ({
  handlerSetComponents, components, id, languages, activeLanguage,
}) => {
  const initialState = {
    type: 'NewsletterSubscribeWidgetReusable',
    scopes: {
      en: [],
      es: [],
      ca: [],
      pt: [],
    },
    successNow: {
      en: 'Thank you for subscribing to this list.',
      es: 'Gracias por suscribirte a esta lista.',
      ca: 'Gracias por suscribirte a esta lista.',
      pt: 'Obrigado por se inscrever nesta lista',
    },
    title: {
      es: 'Suscríbete a nuestro newsletter',
      en: 'Subscribe to our newsletter',
      ca: 'Subscriu-te a la nostra newsletter',
      pt: 'Subscrever a nossa newsletter',
    },
    category: null,
  };
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  const inputHandlerLang = (e) => {
    const { value, name, lang } = e.target;
    const { component } = components[index];
    const comp = {
      ...component,
      [name]: {
        ...component[name],
        [lang.toLowerCase()]: value,
      },
    };
    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };
  const inputHandler = (e) => {
    const { value, name } = e.target;
    const { component } = components[index];
    const comp = {
      ...component,
      [name]: value,
    };
    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const setScope = (e, i) => {
    const { value, lang } = e.target;
    const currentScopeList = [...state.scopes[lang]];
    currentScopeList[i] = value;
    const newScopes = {
      ...state.scopes,
      [lang]: currentScopeList,
    };
    const newState = {
      ...state,
      scopes: newScopes,
    };
    const componentObj = {
      id,
      component: newState,
    };
    setState(newState);
    handlerSetComponents(componentObj, index);
  };

  const inputHandlerScopes = i => (event) => {
    setScope(event, i);
  };

  const addItemHandler = (lang) => {
    const currentScopeList = [...state.scopes[lang]];
    currentScopeList.push('');
    const newScopes = {
      ...state.scopes,
      [lang]: currentScopeList,
    };
    const newState = {
      ...state,
      scopes: newScopes,
    };
    const componentObj = {
      id,
      component: newState,
    };
    setState(newState);
    handlerSetComponents(componentObj, index);
  };
  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    setIndex(componentIndex);
    if (component) {
      setState(component);
    } else {
      const componentObj = {
        id,
        component: state,
      };
      handlerSetComponents(componentObj, componentIndex);
    }
  }, [components]);

  useEffect(() => {
    // const scopeItems = scopesList.filter(item => !scopeNames.includes(item.value));
    // setItems(scopeItems);
  }, [state]);

  return (
    <div className="w-full bg-greyFilter pl-12 rounded-lg py-2 pr-4">
      {languages.map(lang => (
        <div key={lang} className={`w-full ${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'}`}>
          <label htmlFor="title" className="text-xs flex w-full items-center font-americaMonoRegular uppercase text-black pt-0 mt-2">
            Title:
            <input className="ml-1 text-xs w-1/2 font-americaMonoRegular p-1 bg-white outline-none w-full rounded-full" onChange={inputHandlerLang} lang={lang} name="title" placeholder={state.title[lang]} type="text" value={state.title[lang] || ''} />
          </label>
          <label htmlFor="successNow" className="text-xs flex w-full items-center font-americaMonoRegular uppercase text-black pt-0 mt-2">
            Thank you message:
            <input className="ml-1 text-xxs w-1/2 font-americaMonoRegular p-1 bg-white outline-none w-full rounded-full" onChange={inputHandlerLang} lang={lang} name="successNow" placeholder={state.successNow[lang]} type="text" value={state.successNow[lang] || ''} />
          </label>
          <label htmlFor="category" className="text-xs flex w-full items-center font-americaMonoRegular uppercase text-black pt-0 mt-2">
            Category:
            <input className="ml-1 text-xxs w-1/2 font-americaMonoRegular p-1 bg-white outline-none w-full rounded-full" onChange={inputHandler} name="category" placeholder="category" type="text" value={state.category || ''} />
          </label>
          <h2 className="text-xs mb-2 flex w-full items-center font-americaMonoRegular uppercase text-black pt-0 mt-2">
            Scopes:
          </h2>
          {state.scopes[lang].map((scope, i) => (
            <input key={i} className="ml-1 mb-1 text-xs w-1/2 font-americaMonoRegular p-1 bg-white outline-none w-full rounded-full" onChange={inputHandlerScopes(i)} lang={lang} placeholder="scope" type="text" value={state.scopes[lang][i] || ''} />
          ))}
          <button
            type="button"
            onClick={() => addItemHandler(lang)}
            className="font-americaMonoBold text-xs pl-10 pr-6 py-1 h-7 ml-12 my-1 rounded-full uppercase bg-greyFilter flex flex-row items-center"
          >
            add scope
            <span className="font-icon icon-add-button text-base pl-2" />
          </button>
        </div>
      ))}
    </div>
  );
};

NewsletterSubscribeWidgetReusable.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
};

export default NewsletterSubscribeWidgetReusable;
